import { useState, useRef, ReactNode } from 'react';
import useClickOutside from '../../hooks/useClickOutside';
import Button, { ButtonVariant } from '../Buttons/Button';
import { IconType } from 'react-icons';

interface DropdownOption {
    label: string;
    action: () => void;
}

interface ButtonDropdownProps {
    options: DropdownOption[];
    icon?: IconType;
    disabled?: boolean;
    className?: string;
    label?: string;
    iconSize?: number
    variant?: ButtonVariant
    pressAnimation?: boolean;
}

function ButtonDropdown({ options, icon, disabled = false, className = '', label = '', iconSize, variant = 'outline-dark', pressAnimation = true }: ButtonDropdownProps) {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);

    useClickOutside(dropdownRef, () => setIsOpen(false));

    const handleButtonClick = () => {
        if (!disabled) {
            setIsOpen(!isOpen);
        }
    };

    const handleOptionClick = (action: () => void) => {
        action();
        setIsOpen(false);
    };

    return (
        <div className="relative" ref={dropdownRef}>
            <Button
                onClick={handleButtonClick}
                className={className}
                disabled={disabled}
                icon={icon}
                label={label}
                variant={variant}
                iconSize={iconSize}
                pressAnimation={pressAnimation}
            />
            {isOpen && !disabled && (
                <ul className="absolute right-0 mt-1 min-w-[200px] max-w-[400px] w-max rounded-sm bg-primary-100 shadow-custom-dual z-[9999] overflow-hidden">
                    {options.map((option, index) => (
                        <li
                            key={index}
                            onClick={() => handleOptionClick(option.action)}
                            className='cursor-pointer text-llarge py-2 px-3 hover:bg-brand-green-5 transition-all duration-200'
                        >
                            {option.label}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}

export default ButtonDropdown;